import React from 'react'
import { IsJsonString } from '../../../utils/jsonUtils';

const SearchBasedTableOptions = (props) => {
  const tablePropertiesRef = React.useRef(null);
  const [error, setError] = React.useState('')
  const [currentPosition, setCurrentPosition] = React.useState(0);

  React.useEffect(() => {
    if (props.object) {
      
      var currentTableProperties = null;
      var isObject = false;

      try{
        if (typeof props.object.tableProperties === 'string'){
          currentTableProperties = props.object.tableProperties;
          currentTableProperties = JSON.parse(props.object.tableProperties)
          isObject = true
        }
        else {
          // 
          currentTableProperties = props.object.tableProperties
          isObject = true
        }        
      }
      catch(e){
        //alert('parsing error: ' + e);
        console.log(`JSON parsing error: ${e}`);
        // treat it as a string
        currentTableProperties = props.object.tableProperties;
      }

      try {
        if (currentTableProperties && currentTableProperties.additionalMacro) {

          // trying to insert the macro at some determined position
/*

          if (currentPosition) {
            const addedMacro = currentTableProperties.additionalMacro;
            delete currentTableProperties.additionalMacro;
            const stringOfTableProperties = JSON.stringify(currentTableProperties, undefined, 2);
            props.changeSearchBasedTableProperties(props.object.id, stringOfTableProperties.substring(0, currentPosition) + addedMacro + stringOfTableProperties.substring(currentPosition));
          }
          else {
            // otherwise just adding it as end.expression
            const addedMacro = currentTableProperties.additionalMacro;
            delete currentTableProperties.additionalMacro;
            currentTableProperties.end.expression = currentTableProperties.end.expression + ;
          }
*/

          const addedMacro = currentTableProperties.additionalMacro;
          delete currentTableProperties.additionalMacro;
          var newVal = addedMacro + "\r\n"
          if(isObject){
            try{
              // check if JSON
              JSON.parse(currentTableProperties.tablePropertiesAsObject)
              // if not
              newVal = newVal + JSON.stringify(currentTableProperties.tablePropertiesAsObject, undefined, 2)
            }
            catch(e){
              // not JSON
              if(typeof currentTableProperties.tablePropertiesAsObject == 'string')                
                newVal = newVal + currentTableProperties.tablePropertiesAsObject
              else 
                newVal = newVal + JSON.stringify(currentTableProperties.tablePropertiesAsObject, undefined, 2)
            }            
          }
          else {
            newVal = newVal + currentTableProperties
          }

          props.changeSearchBasedTableProperties(props.object.id, newVal)
          validateInputIfCorrect(newVal)

        }
      }
      catch(e) {
        console.log('updating field error:'+e)
        delete currentTableProperties.additionalMacro;
        props.changeSearchBasedTableProperties(props.object.id, JSON.stringify(currentTableProperties))
      }
    }
  }, [props])

  const handleChangeTableProperties = (event) => {
    return validateInputIfCorrect(event.target.value)
  }

  const validateInputIfCorrect = (val) => {
    if (IsJsonString(val)) {
      // update .tableProperties with the parsed version
      props.changeSearchBasedTableProperties(props.object.id, JSON.parse(val))      
      //props.object.tableProperties = JSON.parse(event.target.value);
      
      // no error
      setError('')
    }
    else {
      // otherwise it was failed JSON so we process it as exception
      try{
        // as we have invalid json so
        // try to parse JSON to generate exception
        JSON.parse(val);
      }
      catch(e){
        console.log(`Property contains invalid JSON: ${e}`);        
        setError(`Property contains invalid JSON: ${e}`);   
      }
      // updating value 
      props.changeSearchBasedTableProperties(props.object.id, val)
    }

  }

  const handleClickTableProperties = (event) => {
    props.handleEnterExpandArea()
    if (tablePropertiesRef && tablePropertiesRef.current) {
      setCurrentPosition(tablePropertiesRef.current.selectionStart);
    }
  }

  const handlePressTableProperties = (event) => {
    props.handleEnterExpandArea()
    
    if (tablePropertiesRef && tablePropertiesRef.current) {
      setCurrentPosition(tablePropertiesRef.current.selectionStart + 1);
    }
    
  }

  const handleMouseEnter = () => {
    props.handleEnterExpandArea()
  }

  const handleMouseLeave = () => {
    props.handleLeaveExpandArea()
  }

  return (
    <div className="object-options-body">
      <div className="form-group row">
        <label htmlFor="objectNameField" className="col-sm-3 col-form-label">Name</label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            id="objectNameField"
            placeholder="Name"
            value={props.object.name}
            onChange={(e) => props.changeObjectName(props.object.id, e.target.value)}
          />
        </div>
      </div>

      <div className="form-group row">
        <label className="col-sm-3 col-form-label">Type</label>
        <div className="col-sm-9">
          <input
            type="text"
            className="form-control"
            value="Search-based Table"
            disabled={true}
          />
        </div>
      </div>

      <div className="form-group row">
        <label htmlFor="objectValueField" className="col-sm-12 col-form-label">
          JSON for finding the table: <a href="https://apidocs.pdf.co/kb/Document%20Parser%20(document-parser)/document-parser-template-guide#search-based-table-object" target="_blank">view docs</a>
          <button onClick={props.openMacrosModal} className="btn btn-secondary mT-10 pull-right">
            Insert Macro..
          </button>          
          &nbsp; <span className="text-danger col-form-label">{error}</span>
        </label>
        <div className="col-sm-12">          
          <textarea
            className="form-control"
            name="searchBasedTablePropertiesField"
            id="searchBasedTablePropertiesField"
            cols="50" rows="22"
            value={(typeof props.object.tableProperties === 'string' ? props.object.tableProperties : JSON.stringify(props.object.tableProperties, undefined, 2))}
            onChange={(evt) => handleChangeTableProperties(evt)}
            ref={tablePropertiesRef}
            //onClick={handleClickTableProperties}
            //onKeyDown={handlePressTableProperties}
            //onMouseEnter={() => handleMouseEnter()}
            //onMouseLeave={() => handleMouseLeave()}
          >
          </textarea>
        </div>
      </div>
      <div className="form-group row">
        <div className="col-sm-12">
        </div>
      </div>
    </div>
  );
}
export default SearchBasedTableOptions
